var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 5.33333C2.2988 5.33333 2.00033 5.63181 2.00033 6V12.6667C2.00033 13.0349 2.2988 13.3333 2.66699 13.3333H13.3337C13.7018 13.3333 14.0003 13.0349 14.0003 12.6667V6C14.0003 5.63181 13.7018 5.33333 13.3337 5.33333H2.66699ZM0.666992 6C0.666992 4.89543 1.56242 4 2.66699 4H13.3337C14.4382 4 15.3337 4.89543 15.3337 6V12.6667C15.3337 13.7712 14.4382 14.6667 13.3337 14.6667H2.66699C1.56242 14.6667 0.666992 13.7712 0.666992 12.6667V6Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25278 1.91904C5.62785 1.54397 6.13656 1.33325 6.66699 1.33325H9.33366C9.86409 1.33325 10.3728 1.54397 10.7479 1.91904C11.1229 2.29411 11.3337 2.80282 11.3337 3.33325V13.9999C11.3337 14.3681 11.0352 14.6666 10.667 14.6666C10.2988 14.6666 10.0003 14.3681 10.0003 13.9999V3.33325C10.0003 3.15644 9.93009 2.98687 9.80506 2.86185C9.68004 2.73682 9.51047 2.66659 9.33366 2.66659H6.66699C6.49018 2.66659 6.32061 2.73682 6.19559 2.86185C6.07056 2.98687 6.00033 3.15644 6.00033 3.33325V13.9999C6.00033 14.3681 5.70185 14.6666 5.33366 14.6666C4.96547 14.6666 4.66699 14.3681 4.66699 13.9999V3.33325C4.66699 2.80282 4.87771 2.29411 5.25278 1.91904Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.07f7de60e4df25395a3a76bcc30a0896.svg";
export { ForwardRef as ReactComponent };